import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  isApplied: false,
  currentStep: 1,
  completedPercentage: 0,
};

const individualSlice = createSlice({
  name: "individual",
  initialState,
  reducers: {
    setIndividualOnboarding: (state, action) => {
      const { status, isApplied, currentStep, completedPercentage } =
        action.payload || {};

      if (typeof status !== "undefined") state.status = status;
      if (typeof isApplied !== "undefined") state.isApplied = isApplied;
      if (typeof currentStep !== "undefined") state.currentStep = currentStep;
      if (typeof completedPercentage !== "undefined")
        state.completedPercentage = completedPercentage ?? 0;
    },
    setIndividualCompletedPercentage: (state, action) => {
      state.completedPercentage = action.payload ?? 0;
    },
    resetIndividualOnboarding: () => initialState,
  },
});

export const {
  setIndividualOnboarding,
  setIndividualCompletedPercentage,
  resetIndividualOnboarding,
} = individualSlice.actions;

export default individualSlice.reducer;

